export const LIST_SERVICE_PRICE_PARTNER_REQUEST =
  'LIST_SERVICE_PRICE_PARTNER_REQUEST'
export const LIST_SERVICE_PRICE_PARTNER_SUCCESS =
  'LIST_SERVICE_PRICE_PARTNER_SUCCESS'
export const LIST_SERVICE_PRICE_PARTNER_FAIL = 'LIST_SERVICE_PRICE_PARTNER_FAIL'

export const DELETE_SERVICE_PRICE_PARTNER_REQUEST =
  'DELETE_SERVICE_PRICE_PARTNER_REQUEST'
export const DELETE_SERVICE_PRICE_PARTNER_SUCCESS =
  'DELETE_SERVICE_PRICE_PARTNER_SUCCESS'
export const DELETE_SERVICE_PRICE_PARTNER_FAIL =
  'DELETE_SERVICE_PRICE_PARTNER_FAIL'

export const SUMMARY_SELECT_SERVICE_PRICE_REQUEST =
  'SUMMARY_SELECT_SERVICE_PRICE_REQUEST'
export const SUMMARY_SELECT_SERVICE_PRICE_SUCCESS =
  'SUMMARY_SELECT_SERVICE_PRICE_SUCCESS'
export const SUMMARY_SELECT_SERVICE_PRICE_FAIL =
  'SUMMARY_SELECT_SERVICE_PRICE_FAIL'

export const LIST_SERVICE_PRICE_CATEGORY_REQUEST =
  'LIST_SERVICE_PRICE_CATEGORY_REQUEST'
export const LIST_SERVICE_PRICE_CATEGORY_SUCCESS =
  'LIST_SERVICE_PRICE_CATEGORY_SUCCESS'
export const LIST_SERVICE_PRICE_CATEGORY_FAIL =
  'LIST_SERVICE_PRICE_CATEGORY_FAIL'

export const ADD_SERVICE_PRICE_CATEGORY_REQUEST =
  'ADD_SERVICE_PRICE_CATEGORY_REQUEST'
export const ADD_SERVICE_PRICE_CATEGORY_SUCCESS =
  'ADD_SERVICE_PRICE_CATEGORY_SUCCESS'
export const ADD_SERVICE_PRICE_CATEGORY_FAIL = 'ADD_SERVICE_PRICE_CATEGORY_FAIL'

export const DETAIL_SERVICE_PRICE_CATEGORY_REQUEST =
  'DETAIL_SERVICE_PRICE_CATEGORY_REQUEST'
export const DETAIL_SERVICE_PRICE_CATEGORY_SUCCESS =
  'DETAIL_SERVICE_PRICE_CATEGORY_SUCCESS'
export const DETAIL_SERVICE_PRICE_CATEGORY_FAIL =
  'DETAIL_SERVICE_PRICE_CATEGORY_FAIL'
  
export const DETAIL_SERVICE_PRICE_PARTNER_REQUEST =
'DETAIL_SERVICE_PRICE_PARTNER_REQUEST'
export const DETAIL_SERVICE_PRICE_PARTNER_SUCCESS =
'DETAIL_SERVICE_PRICE_PARTNER_SUCCESS'
export const DETAIL_SERVICE_PRICE_PARTNER_FAIL =
'DETAIL_SERVICE_PRICE_PARTNER_FAIL'

export const DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_REQUEST =
'DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_REQUEST'
export const DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_SUCCESS =
'DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_SUCCESS'
export const DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_FAIL =
'DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_FAIL'